module.exports = __webpack_public_path__ + "img/f6_en.99f45bbe.svg";